import React, { createContext, useContext } from 'react';

/**
 * Caminho base da API de topologia, injetado por quem monta a tela.
 *
 * As mesmas 26 telas servem duas audiências com regras diferentes de acesso:
 *
 *   admin   -> /admin/topology/{empresa_id}/...   a empresa vem de um seletor
 *   cliente -> /topology/...                      a empresa vem do TOKEN
 *
 * Duplicar a árvore inteira para trocar um prefixo criaria duas cópias de 3.700
 * linhas de lógica de visualização que divergiriam no primeiro ajuste. E deixar
 * o caminho montado dentro de cada componente foi o que espalhou
 * `/admin/topology/${empresaId}` por onze arquivos.
 *
 * O valor `null` significa "ainda não há o que consultar" — no admin, enquanto
 * nenhuma empresa foi escolhida. Cada hook guarda com `if (!base) return`, então
 * o mesmo teste cobre "sem empresa selecionada" e "provider ausente", em vez de
 * cada arquivo ter a própria checagem de empresaId.
 *
 * A empresa NÃO aparece no caminho do cliente de propósito: a API resolve pelo
 * token. Se ela viesse daqui, bastaria um bug de estado nesta tela para pedir a
 * rede de outro provedor.
 */
const TopologyApiContext = createContext(null);

export function TopologyApiProvider({ base, children }) {
  return (
    <TopologyApiContext.Provider value={base || null}>
      {children}
    </TopologyApiContext.Provider>
  );
}

/** Caminho base, ou null quando não há empresa resolvida. */
export function useTopologyBase() {
  return useContext(TopologyApiContext);
}
